<template>
    <div class="py-2 flex flex-col items-start justify-center">
        <div v-if="is_active && envelopes_available"
            class="flex items-center justify-start"
        >
            <div class="text-lg text-green-warm-600">
                <i class="far fa-check-circle"></i>
            </div>

            <p class="text-md text-green-warm-600 ml-2">
                Docusign is enabled, {{ envelopes_available }} {{ envelopes_available === 1 ? 'envelope' : 'envelopes' }} available
            </p>
        </div>

        <div v-else-if="has_error"
            class="flex items-center justify-start"
        >
            <p class="text-md text-red-600 ml-2">
                Docusign error
            </p>
        </div>

        <div v-else-if="is_active && ! envelopes_available"
            class="flex items-center justify-start"
        >
            <p class="text-md text-green-warm-600 ml-2">
                0 Docusign envelopes available
            </p>
        </div>

        <div v-else-if="is_activating"
            class="flex items-center justify-start"
        >
            <div class="text-lg text-blue-600">
                <i class="fas fa-spinner fa-spin"></i>
            </div>

            <p class="text-md text-blue-600 ml-2">
                Enabling Docusign (approximately 1 minute) ...
            </p>
        </div>

        <div v-else>
            <p class="text-md text-gray-500 ml-2">
                <button type="button" class="text-blue-600 underline" @click="activate">Enable Docusign</button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        has_active_docusign_user: { default: false },
        docusign_user: {},
        envelopes_available: {},
    },

    data() {
        return {
            is_active: this.has_active_docusign_user,
            is_activating: false,
            polling_timer: null,
            activation_error: false,
            polling_count: 0,
            docusign_user_proxy: this.docusign_user,
        }
    },

    computed: {
        has_error() {
            return this.activation_error || (this.docusign_user_proxy && this.docusign_user_proxy.error);
        },
    },

    mounted() {
        if (!this.is_active && !this.has_error) this.activate();
    },

    beforeDestroy() {
        clearTimeout(this.polling_timer);
    },

    methods: {
        activate() {
            if (this.is_activating) return;
            this.polling_count = 0;
            this.is_activating = true;

            axios.post('/docusign/activate')
                .then(response => {
                    this.getActivationStatus();
                })
                .catch(error => {
                    this.is_activating = false;
                    this.activation_error = true;
                });
        },
        getActivationStatus() {
            axios.get('/docusign/activate')
                .then(response => {
                    this.docusign_user_proxy = response.data;

                    if (response.data && response.data.ready_at) {
                        this.is_activating = false;
                        this.is_active = true;

                        window.location.reload();
                    } else {
                        if (this.polling_count >= 60) {
                            console.log('Pause polling')
                            this.is_activating = false;
                            this.is_active= false;
                            return;
                        }

                        this.polling_timer = setTimeout(() => {
                            this.getActivationStatus();
                            this.polling_count ++;
                        }, 5000);
                    }
                })
                .catch(error => {
                    this.is_activating = false;
                    this.activation_error = true;
                });
        },
    },
}
</script>
